import Input from '@material-ui/core/Input'
import React from 'react'

class ListInput extends React.Component {
  state = {
    isUnderline: false,
  }

  render() {
    return (
      <Input
        title={this.props.value}
        name={this.props.name}
        error={this.props.hasError(this.props.name, this.props.value)}
        value={this.props.value}
        placeholder={
          this.props.placeholder ? this.props.placeholder : 'Podaj opis'
        }
        onFocus={() => this.toggleUnderline()}
        onBlur={() => this.toggleUnderline()}
        disableUnderline={this.underlineDisabled()}
        onChange={c => this.props.onValueChange(c.target.value)}
      />
    )
  }

  underlineDisabled() {
    return this.props.hasError(this.props.name)
      ? false
      : !this.state.isUnderline
  }

  toggleUnderline() {
    this.setState({ isUnderline: !this.state.isUnderline })
  }
}

export default ListInput
